import * as Yup from 'yup'

export const listValidationSchema = Yup.object({
  list_type: Yup.string().required('Required'),
  title: Yup.string().required('Required'),
  description: Yup.string().required('Required'),
  isAudioList: Yup.boolean().optional(),
})
